import Crud from '../views/Receita/Crud'
import Entity from '../views/Receita/Add'

let routes = {
    path: '/receitas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/receitas/add',
            name: 'NewReceita',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Receita',
                breadcrumb: [
                    {
                        text: 'Receitas',
                        active: false,
                        to: '/receitas',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/receitas/edit/:id?',
            name: 'EditReceita',
            component: Entity,
            meta: {
                pageTitle: 'Editar Receita',
                breadcrumb: [
                    {
                        text: 'Receitas',
                        active: false,
                        to: '/receitas',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/receitas',
            name: 'list-receitas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Receitas',
                breadcrumb: [
                    {
                        text: 'Receitas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
